import styled from 'styled-components';

export const StyledWithoutGraphic = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  font-family: Poppins,Heltica,Arial,sans-serif;
  background-color: #ECEDF2;
  color: #333333;
  max-width: 1190px;
  margin: 0 auto 30px;
  padding: 20px 30px;
  text-align: left;
  
  img {
    margin-right: 25px;
  }
  
  p {
    font-size: 14px;
    line-height: 1.5em;
  }
  
  .container-text {
    max-width: 850px; 
  }
`;
